var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cube-mobile-simulator"},[_c('iframe',{ref:"iframe",attrs:{"frameborder":"0","src":_vm.demoUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }